export default {
  title: "Partner"
  , form: {
    descripcion: {
      label: "Descripción"
      , th: "Descripción"
    }
  }
  , errors: {
    BD5020: { text: "Ocurrió un error en el catálogo de Partner" }
    , WS5020: { text: "Ocurrió un error en el catálogo de Partner" }
    , JS5020: { text: "Ocurrió un error en el catálogo de Partner" }
    , C55020: { text: "Ocurrió un error en el catálogo de Partner" }
    , UK_Partner: { text: "Ya existe un registro con el mismo código" }
  }
}


// WEBPACK FOOTER //
// ./src/locales/languages/es_MX/view/operativos/partner.js